// src/services/ConsolidatedInvoiceService.js
import requestInstance from "./Request";

const BASE_URL = `${process.env.REACT_APP_B2B_API_BASE_URL}/billing/v2`;

const consolidatedInvoiceService = {
  // POST: Generate consolidated invoice for multi-day extension
  async generateConsolidatedInvoice(parentTripId) {
    try {
      const payload = {
        parentTripId: parentTripId,
      };
      
      const response = await requestInstance.post(
        `${BASE_URL}/consolidated/multi-day-extension`,
        payload
      );
      
      console.log("Consolidated Invoice Response:", response);
      return response.data;
    } catch (error) {
      console.error("Error generating consolidated invoice:", error);
      throw error;
    }
  },
};

export default consolidatedInvoiceService;
